"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Listeners = Listeners;
/**
 * Returns the first element that is a descendant of node that
 * matches selectors.
 */
function Listeners() {
  this.entries = [];
}

/**
 * Keeps track of a listener
 *
 * @param {HTMLElement} element - The element the listener is going to be attached to
 * @param {String} event - The event name we want listen for
 * @param {Function} fn - The function that will get run on the event
 */
Listeners.prototype.add = function add(element, event, fn) {
  this.entries.push({
    element: element,
    event: event,
    fn: fn
  });

  element.addEventListener(event, fn);
};

/**
 * Stop tracking the specific event
 *
 * @param {String} event - The event name we want listen for
 * @param {Function} fn - The function that will get run on the event
 */
Listeners.prototype.remove = function remove(event, fn) {
  var foundListener = this.entries.find(function (listener) {
    return listener.event === event && listener.fn === fn;
  });

  if (foundListener) {
    this.entries = this.entries.filter(function (listener) {
      return listener !== foundListener;
    });

    foundListener.element.removeEventListener(foundListener.event, foundListener.fn);
  }
};

/**
 * Removes all of the tracked events
 */
Listeners.prototype.removeAll = function removeAll() {
  this.entries = this.entries.filter(function (listener) {
    listener.element.removeEventListener(listener.event, listener.fn);

    return false;
  });
};